import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  CompanyMargin,
  CompanyMarginSave,
} from '../company-margins-state.model';

export const CompanyMarginsActions = createActionGroup({
  source: 'Company Margins',
  events: {
    'Load Company Margins': props<{ companyId: number }>(),
    'Load Company Margins Success': props<{ margins: CompanyMargin[] }>(),
    'Load Company Margins Failure': props<{ error: string }>(),
    'Save Company Margins': props<{ margins: CompanyMarginSave[] }>(),
    'Save Company Margins Success': props<{ margins: CompanyMargin[] }>(),
    'Save Company Margins Failure': props<{ error: string }>(),
    'Reset State': emptyProps(),
  },
});
